import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VisualRefinement } from '../Refinements/VisualRefinement';

const VisualDimension = ({
  dimension,
  onChange,
  selectedRefinements
}) => {

  const {
    dimensionId = '',
    refinements = []
  } = dimension || {};

  const wrapperClassNames = classNames(
    'sui-max-h-[415px]', 'sui-overflow-y-auto', 'sui-mx-auto',
    'sui-my-0', 'sui-mb-2', 'sui-flex', 'sui-justify-center'
  );

  return (
    <section className={wrapperClassNames}>
      <VisualRefinement
        dimension={dimension}
        refinements={refinements}
        onChange={onChange}
        dimensionId={dimensionId}
        selectedRefinements={selectedRefinements}
      />
    </section>
  );
};

VisualDimension.propTypes = {
  dimension: PropTypes.shape({
    dimensionId: PropTypes.string,
    label: PropTypes.string,
    refinements: PropTypes.arrayOf(
      PropTypes.shape({})
    )
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedRefinements: PropTypes.arrayOf(PropTypes.shape({}))
};

VisualDimension.displayName = 'VisualDimension';

export { VisualDimension };
